import { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import pathnames from "routes/pathnames";

import api from "services/api";

import getQueryParams from "common/get-query-params";
import encodeQueryParams from "common/encode-query-params";
import serveRequestErrors from "common/serve-request-errors";

import ErrorResponseDto from "dto/services/error-response-dto";
import PageOfficeLocationDto, { PageOfficeLocationTableQueryParamsDto } from "dto/pages/office-location/page-office-location-list";

import Button from "components/app-button";
import AppHeading from "components/app-heading";
import AppOfficeLocationTable from "components/pages/office-location/app-office-location-table";

const PageOfficeLocationListing = () => {
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const [location, setLocation] = useState<PageOfficeLocationDto>();
	const [isFetching, setIsFetching] = useState(false);
	const memoSetSearchParams = useRef(setSearchParams);
	const queryParams = useRef(getQueryParams<PageOfficeLocationTableQueryParamsDto>(searchParams, { page: 0 }));

	const onHandleGetLocation = useCallback(async () => {
		setIsFetching(true);

		try {
			const { page } = queryParams.current;

			const payload = { size: 10, page };

			const response = await api.get.location.locations(payload);

			setLocation(response.data?.data?.list);
		} catch (error) {
			const err = error as Error | ErrorResponseDto;

			serveRequestErrors(err);
		} finally {
			setIsFetching(false);
		}
	}, []);

	//prettier-ignore
	const handlePageChange = useCallback((page: number) => {
        queryParams.current.page = page;

        memoSetSearchParams.current(encodeQueryParams(queryParams.current));

        onHandleGetLocation();
    }, [onHandleGetLocation]);

	const navigateToAddNew = useCallback(() => {
		navigate(`${pathnames.officeLocationInfo}create`);
	}, [navigate]);

	useEffect(() => {
		onHandleGetLocation();
	}, [onHandleGetLocation]);

	return (
		<div className="page-office-location">
			<div className="location">
				<AppHeading title="Office Location">
					<AppHeading.Divider />
				</AppHeading>

				<div className="location__button-container">
					<Button label="Add New" onClick={navigateToAddNew} />
				</div>

				<AppOfficeLocationTable locations={location?.content || []} currentPage={location?.number || 0} totalPages={location?.totalPages || 0} onPageChange={handlePageChange} fetching={isFetching} />
			</div>
		</div>
	);
};

export default PageOfficeLocationListing;
